import client from '/src/services/client.js';

export default {
    getLlms : (data) => client.get(`llms/list`, data)
}